"use client"

import { useEffect } from "react"

const CONSENT_COOKIE = "cp_analytics_consent"
const CONSENT_STORAGE_KEY = "cp_analytics_consent"

function getConsent(): "accepted" | "refused" | null {
  const match = document.cookie
    .split("; ")
    .find((part) => part.startsWith(`${CONSENT_COOKIE}=`))

  const value = match?.split("=")[1]
  if (value === "accepted" || value === "refused") return value

  try {
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY)
    if (stored === "accepted" || stored === "refused") return stored
  } catch {
    // no-op
  }

  return null
}

export default function VisitorTracker() {
  useEffect(() => {
    const consent = getConsent()
    if (consent !== "accepted") return

    fetch("/api/visitors/track", {
      method: "POST",
      keepalive: true,
      cache: "no-store",
    }).catch(() => {
      // Tracking best-effort only.
    })
  }, [])

  return null
}
